import { render } from "./SayfaBasligi.vue?vue&type=template&id=1c03adce&scoped=true"
import script from "./SayfaBasligi.vue?vue&type=script&lang=js"
export * from "./SayfaBasligi.vue?vue&type=script&lang=js"

import "./SayfaBasligi.vue?vue&type=style&index=0&id=1c03adce&scoped=true&lang=css"
import "./SayfaBasligi.vue?vue&type=style&index=1&id=1c03adce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c03adce"]])

export default __exports__